import React from 'react';
import { useActiveTooltipCoordinate, useYAxisInverseScale } from 'recharts';

// Echtes Fadenkreuz, das der tatsaechlichen Maus-Y-Position folgt (nicht dem
// naechsten Datenpunkt) - nutzt Recharts' eigene, bereits pixel-genaue
// Koordinate (dieselbe, die auch die vertikale Tooltip-Cursor-Linie
// verwendet), statt sie per DOM-Messung selbst nachzubauen (siehe
// MarketdataDetailPanel.js fuer die Debugging-Historie dazu). Muss als
// deklaratives Kind von <LineChart>/<BarChart> etc. gerendert werden (Chart-
// Kontext), von MarketdataDetailPanel.js UND MarketdataChartTile.js genutzt.
export default function MarketdataChartCrosshair({ onHover }) {
	const activeCoordinate = useActiveTooltipCoordinate();
	const inverseScale = useYAxisInverseScale();

	React.useEffect(() => {
		if (!activeCoordinate || !inverseScale) {
			onHover(null);
			return;
		}
		const value = inverseScale(activeCoordinate.y);
		onHover(typeof value === 'number' ? value : null);
	}, [activeCoordinate, inverseScale, onHover]);

	return null;
}
